import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import API from '../api'
import './IndexPage.css'
import { withRouter } from 'react-router'
import Disclaimer from '../components/Disclaimer'

const API_URL = process.env['REACT_APP_API_URL'] || 'https://calculator.giftillustrator.com/Calculator'

API.setShared(new API(API_URL))
var api = API.getShared()

var digitalData = {};
var exp = (new Date(new Date().setFullYear(new Date().getFullYear() + 1))).toUTCString();

export const IndexCard = props => {
    let bgColor = '#e4e0e1'
    if (typeof props.bgColor !== 'undefined' && props.bgColor !== null) bgColor = props.bgColor
    const Banner = bannerProps => {
      if (bannerProps.bannerLinks.length > 0) {
        return (
          <div className="card" style={{backgroundColor: bgColor}}>
            <div className="header"><h2>{bannerProps.bannerTitle}</h2></div>
            <div className="body">
              <div className="body-content">
                <p>{bannerProps.bannerContent}</p>
              </div>
            </div>
            <div className="card-links">
              {bannerProps.bannerLinks.map(prop =>
                <Link key={prop.backendKey} to={`/${props.clientName}/${prop.slug}`}> {prop.name} </Link>
              )}
            </div>
          </div>
        )
      }
      else {
        return (
          null
        )
      }
    }

    const payIncome = props.enabledPages.filter(x => ['cga','crat'].indexOf(x.backendKey) !== -1)
    // Defining order of links. 0 og 1 bs 2 clat
    const makeToday = props.enabledPages.filter(x => ['og','clat'].indexOf(x.backendKey) !== -1).sort((a,b)=>{
        if(a.backendKey === 'og') return -1
        if(b.backendKey === 'og') return 1
        return 0
    })

    const makeImpact = props.enabledPages.filter(x => ['bs','rle'].indexOf(x.backendKey) !== -1).sort((a,b)=>{
        if(a.backendKey === 'bs') return -1
        if(b.backendKey === 'bs') return 1
        return 0
    })

    const totalCardsClass = payIncome.length > 0 && makeToday.length > 0 && makeImpact.length > 0 ? ' three-cards' : ' not-three-cards';

    return (
        <div className={"gift-types flex-row-nowrap--wrap-cond" + totalCardsClass}>
            <Banner bannerTitle='Gifts&nbsp;That Pay&nbsp;You&nbsp;Income' bannerContent='Here are win-win ways you can support our work while receiving payments for&nbsp;life.' bannerLinks={[...payIncome]} ></Banner>
            <Banner bannerTitle='Gifts&nbsp;You Make&nbsp;Today' bannerContent='See your generosity in action! These gifts will support our mission today and may offer you tax&nbsp;advantages.' bannerLinks={[...makeToday]} ></Banner>
            <Banner bannerTitle='Gifts&nbsp;Of&nbsp;Assets' bannerContent='Enjoy the tax rewards of a gift of real estate or other non-cash asset. Here’s how you can&nbsp;benefit.' bannerLinks={[...makeImpact]} ></Banner>
        </div>
    )
}

class Index extends Component {

    state = {
        clientDefaults: null,
    }
    componentDidMount() {
        this.updateClientDefaultsIndex()
        document.body.style.backgroundColor = '#fff'
        digitalData = {
            page:{
                pageInfo:{
                    pageName: this.props.match.params.clientName.toLowerCase()+":gift illustrator home",
                    pageType: "Gift Illustrator"
                },
                prefix: {
                    sitePrefix: this.props.match.params.clientName.toLowerCase()
                },
                siteSection: {
                    section1: "planned giving",
                    section2: "subpage",
                    section3: "gift illustrator"
                }
            }
        }
        
        // set internalExternal value
        var secureCookie = window.location.protocol === 'https:' ? ' secure;': '';
        if (this.props.location.search.indexOf('visit=int_s') > -1) {
            digitalData["internalExternal"] = "internal_stelter";
            document.cookie = "Stl_Visit_Stelter=true; samesite=lax;" + secureCookie + " expires=" + exp + ";";
        } else if (this.props.location.search.indexOf('visit=int_c') > -1) {
            digitalData["internalExternal"] = "internal_client";
            document.cookie = "Stl_Visit_Client=true; samesite=lax;" + secureCookie + " expires=" + exp + ";";
        } else {
            digitalData["internalExternal"] = "external";
        }

        digitalData = JSON.stringify(digitalData);
    }

    componentDidUpdate(prevProps, prevState) {
        // eslint-disable-next-line
        prevProps.clientName !== this.props.clientName ? this.updateClientDefaultsIndex() : null  

        digitalData = {
            page:{
                pageInfo:{
                    pageName: this.props.match.params.clientName.toLowerCase()+":gift illustrator home",
                    pageType: "Gift Illustrator"
                },
                prefix: {
                    sitePrefix: this.props.match.params.clientName.toLowerCase()
                },
                siteSection: {
                    section1: "planned giving",
                    section2: "subpage",
                    section3: "gift illustrator"
                }
            }
        }
        
        // set internalExternal value
        var secureCookie = window.location.protocol === 'https:' ? ' secure;': '';
        if (this.props.location.search.indexOf('visit=int_s') > -1) {
            digitalData["internalExternal"] = "internal_stelter";
            document.cookie = "Stl_Visit_Stelter=true; samesite=lax;" + secureCookie + " expires=" + exp + ";";
        } else if (this.props.location.search.indexOf('visit=int_c') > -1) {
            digitalData["internalExternal"] = "internal_client";
            document.cookie = "Stl_Visit_Client=true; samesite=lax;" + secureCookie + " expires=" + exp + ";";
        } else {
            digitalData["internalExternal"] = "external";
        }

        digitalData = JSON.stringify(digitalData);
    }

    async updateClientDefaultsIndex() {
        const clientName = this.props.match.params.clientName

        this.setState({
            clientDefaults: null,
            error: null,
        })

        try {
            const { newDefaults, pages } = await Promise.all([
                api.clientDefault(clientName),
                import('./../pages.json').then(x => x.default)
            ]).then(data => Object.assign({},{
                newDefaults: data[0],
                pages: data[1]
            }))

            newDefaults.clientName = clientName
            this.setState({
                clientDefaults: newDefaults,
                pages: pages
            })
        } catch (e) {
            this.setState({error: e})

            // So Sentry catches it
            setTimeout(() => { throw e }, 0)
        }
    }

    render() {
        var clientDefaults = this.state.clientDefaults

        if (this.state.error) return (<div>There was a problem loading Gift Illustrator. Please try again later.</div>)

        var pagesProps = clientDefaults && this.state.pages
                .filter(page => clientDefaults[`${page.backendKey}Enabled`] === 'true')

        return (
            <div id="index" className='home-page'>
                <h1 id="pageTitle">Begin Your Personalized Example</h1>
                <div className="gift-types flex-column">
                    { pagesProps ? <IndexCard enabledPages={pagesProps} clientName={clientDefaults.name} bgColor={clientDefaults.bgColor}/> : null }
                </div>
                { pagesProps ? <Disclaimer clientName={clientDefaults.name} /> : null }
            </div>
        )
    }
}

export default withRouter(Index);